import { z } from 'zod';
export const getOrganizationTreeFunctionDef = {
    name: 'getOrgTree',
    requestSchema: z.object({
        search: z.string().optional(),
        initialOrganizationIds: z.string().array().optional(),
        filterData: z
            .object({
            search: z.string().min(3).optional(),
            permission: z.enum(['manage', 'member']).optional(),
            pending: z.boolean().optional(),
        })
            .optional(),
        staticFilters: z
            .object({
            visible: z.boolean().optional(),
            orgPermissions: z.string().array().optional(),
            permission: z.enum(['member']).optional(),
        })
            .optional(),
        parentId: z.string().uuid().optional(),
        parentPath: z.string().optional(),
        maxDepth: z.number().optional().default(3),
        // do not allow expanding more than 500 items as this will crash UI
        maxExpandedIds: z.number().optional().default(500),
    }),
    responseSchema: z.object({
        organizations: z.any(),
        highlightedIds: z.string().array(),
    }),
};
